import { useMemo } from "react";
import type { ScaleLinear } from "d3";

import { scale } from "../data/vizGeometry.js";

// Display labels for the y-axis (different from data values)
const displayLabels: Record<string, string> = {
  "Section 136": "S136",
  "Section 17A": "CTO",
  "Section 17A (Recalled)": "CTO (Rec.)",
};

type AxisLeftProps = {
  yScale: ScaleLinear<number, number>;
};

export const AxisLeft = ({ yScale }: AxisLeftProps) => {
  const ticks = useMemo(() => {
    // One tick per discrete status level (dedup the shared 0 = Not Detained /
    // Expired), rather than d3's `ticks()`, which can emit values with no
    // matching level (e.g. non-integers or a level beyond the top of the scale).
    const seenLevels = new Set<number>();
    return scale.flatMap(([name, value]) => {
      if (seenLevels.has(value)) {
        return [];
      }
      seenLevels.add(value);
      return [
        {
          value,
          label: displayLabels[name] ?? name,
          // Center the label vertically within the segment (each segment is 1 unit tall)
          yOffset: yScale(value + 0.5),
        },
      ];
    });
  }, [yScale]);

  return (
    <>
      {/* Ticks and labels */}
      {ticks.map(({ value, label, yOffset }) => (
        <g key={value} transform={`translate(-50, ${String(yOffset)})`}>
          <text
            key={value}
            style={{
              fontSize: "8px",
              textAnchor: "start",
              dominantBaseline: "middle",
              fill: "black",
            }}
          >
            {label}
          </text>
        </g>
      ))}
    </>
  );
};
